import React, { useState, useEffect } from "react";
import "../LiveVod.scss";
import LoadingComp from "components/GlobalComponents/LoadingComp/LoadingComp";
import DynamicButton from "components/GlobalComponents/DynamicButton/DynamicButton";
import { useTranslation } from "react-i18next";
import LiveStreamComp from "../LiveStreamComp";
import { useHistory } from "react-router";
import { fetchChannelVideos } from "../../../API/youtube";

export default function StrukturaVod({ name }) {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [t] = useTranslation();
  const history = useHistory();

  useEffect(() => {
    if (!name) return;
    fetchChannelVideos({ maxResults: 12, query: name })
      .then(({ videos: results }) => {
        setVideos(results.slice(0, 6));
      })
      .catch((err) => console.error("Failed to fetch YouTube videos:", err))
      .finally(() => setLoading(false));
  }, [name]);

  if (!name) {
    return <div>error</div>;
  }

  return (
    <div>
      <div className={`news-related-cards`}>
        <strong>
          <h2>{t("LIVE/VOD")}</h2>
        </strong>
      </div>
      <div className="live-vod-vertical">
        <div className="live-vod-wrapper">
          {loading ? (
            <div className="loading-space">
              <LoadingComp loading={true} />
            </div>
          ) : (
            videos.map((video) => (
              <LiveStreamComp
                key={video.id}
                videoId={video.id}
                title={video.title}
                isLive={video.isLive}
              />
            ))
          )}
        </div>
        <DynamicButton
          text={t("navigation.more")}
          action={() => history.push("/live-vod")}
          type="secondary"
        />
      </div>
    </div>
  );
}
